export default __webpack_public_path__ + "static/logo-vertical-8df4ef0253b27e851144e760137c0484.svg";